__turbopack_context__.v({
  "activeTab": "Features-module__oVnRKG__activeTab",
  "container": "Features-module__oVnRKG__container",
  "content": "Features-module__oVnRKG__content",
  "cta": "Features-module__oVnRKG__cta",
  "description": "Features-module__oVnRKG__description",
  "featureImage": "Features-module__oVnRKG__featureImage",
  "features": "Features-module__oVnRKG__features",
  "points": "Features-module__oVnRKG__points",
  "tab": "Features-module__oVnRKG__tab",
  "tabs": "Features-module__oVnRKG__tabs",
  "textColumn": "Features-module__oVnRKG__textColumn",
  "title": "Features-module__oVnRKG__title",
  "visualCard": "Features-module__oVnRKG__visualCard",
});
